import fetch from 'cross-fetch'
import URLSearchParams from 'url-search-params';

export class ApiError extends Error {
  constructor(message, code) {
    super(message);
    this.code = code;
    this.name = "ApiError";
  }
}

export class AuthError extends ApiError {
  constructor(...args) {
    super(...args);
    this.name = "AuthError";
  }
}

export class ServerError extends ApiError {
  constructor(...args) {
    super(...args);
    this.name = "ServerError";
  }
}

const decorate = (response) => {
  const getServerError = () => {
    const {statusText: message, status: code} = response;

    if (code > 499) {
      return new ServerError(message, code);
    }
  }

  const getResponseError = () => {
    const code = parseInt(response.headers.get('x-error-code'));
    const msg = response.headers.get('x-error');

    if (code === 100) {
      return new AuthError(msg, code);
    } else if (code > 0) {
      return new ApiError(msg, code);
    }
  }

  return {
    getError() {
      return getServerError() || getResponseError() || null;
    },
  }
};

function handleErrors(r) {
  const e = decorate(r).getError();
  if (e) {
    throw e;
  }
  return r;
}

export const api = ({baseUrl, consumerKey}) => {
  // Constants
  const params = {
    headers: {
      'Content-Type': 'application/json',
      'X-Accept': 'application/json; charset=UTF8 ',
    },
    credentials: 'include',
  };
  const defaultQuery = {
    consumer_key: consumerKey,
    enable_cors: '1',
  };

  // Private
  const getQuery = (params = {}) => (new URLSearchParams({...defaultQuery, ...params}).toString());
  const getUrl = (endpoint, params = {}) => `${baseUrl}${endpoint}?${getQuery(params)}`;

  const post = (path, data = {}) => {
    const url = getUrl(path, defaultQuery);

    return fetch(url, {
      ...params,
      body: JSON.stringify(data),
      method: 'POST',
    }).then(handleErrors);
  }

  // Public
  return {
    save(url) {
      return post('/add', {url});
    },
    subscriptionCreate({planId,stripeToken, promotionCode}) {
      return post('/subscription', {planId, stripeToken, promotionCode});
    },
    track(actionOrActions) {
      const actions = Array.isArray(actionOrActions) ? actionOrActions : [actionOrActions];

      return post('/pv', {actions});
    }
  }
};
